enum NotifyType {
  SAVE_SUCCESS = "SAVE_SUCCESS",
  SAVE_FAILURE = "SAVE_FAILURE",
  DELETE_SUCCESS = "DELETE_SUCCESS",
  DELETE_FAILURE = "DELETE_FAILURE",
  FETCH_FAILURE = "FETCH_FAILURE",
  MAIL_SEND_SUCCESS = "MAIL_SEND_SUCCESS",
  OPTIONAL_FAILURE = "OPTIONAL_FAILURE",
  OPTIONAL_SUCCESS = "OPTIONAL_SUCCESS",
}

export default NotifyType;
